export default __webpack_public_path__ + "locales/hy-AM/PrivacyPage.json?hash=bceff71a1d475022683160667fcd3897";